import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { StudentstoriesRoutingModule } from './studentstories-routing.module';
import { StudentstoriesListComponent } from './studentstories-list/studentstories-list.component';
import { StudentstoriesCreateComponent } from './studentstories-create/studentstories-create.component';

@NgModule({
  declarations: [StudentstoriesListComponent, StudentstoriesCreateComponent],
  imports: [
    CommonModule,
    StudentstoriesRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class StudentstoriesModule { }
